import React from 'react';

export const EyeIcon = ({ open, hovered }) => (
  open ? (
    <svg width={hovered? "20" : "18"} height={hovered? "20" : "18"} viewBox="0 0 20 20" fill="none" style={{ display: 'inline', verticalAlign: 'middle' }}>
      <ellipse cx="10" cy="10" rx="7" ry="4" stroke={hovered ? 'var(--primary-color)' : 'var(--primary-color)'} strokeWidth="2" fill="none" />
      <line x1="4" y1="16" x2="16" y2="4" stroke={hovered ? 'var(--primary-color)' : 'var(--primary-color)'} strokeWidth="2" />
    </svg>
  ) : (
    <svg width={hovered? "20" : "18"} height={hovered? "20" : "18"} viewBox="0 0 20 20" fill="none" style={{ display: 'inline', verticalAlign: 'middle' }}>
      <ellipse cx="10" cy="10" rx="7" ry="4" stroke={hovered ? 'var(--primary-color)' : 'var(--primary-color)'} strokeWidth="2" fill="none" />
      <circle cx="10" cy="10" r="2" fill={hovered ? 'var(--primary-color)' : 'var(--primary-color)'} />
    </svg>
  )
);

export const LinkOutIcon = ({ hovered }) => (
  <svg width={hovered? 20 : 18} height={hovered? 20 : 18} viewBox="0 0 20 20" fill="none" style={{ display: 'inline', verticalAlign: 'middle' }}>
    <path d="M7 13l6-6" stroke={hovered ? '#f0c000' : 'var(--primary-color)'} strokeWidth="2" strokeLinecap="round" />
    <path d="M11 7h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h2" stroke={hovered ? '#f0c000' : 'var(--primary-color)'} strokeWidth="2" strokeLinejoin="round" fill="none" />
  </svg>
);

export const ArrowDownIcon = () => (
  <svg width="14" height="14" viewBox="0 0 20 20" fill="none" style={{ marginLeft: 6, verticalAlign: 'middle' }}>
    <path d="M6 8l4 4 4-4" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const InfoIcon = ({ size = 16, color = 'var(--primary-color)', style = {} }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" style={{ display: 'inline', verticalAlign: 'middle', ...style }}>
    <circle cx="10" cy="10" r="9" stroke={color} strokeWidth="2" fill="none" />
    <circle cx="10" cy="6.5" r="1.2" fill={color} />
    <rect x="9" y="9" width="2" height="6" rx="1" fill={color} />
  </svg>
); 